import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";
import {
  FeedbackAnalytics,
  Feedback,
  FeedbackMessages,
  FeedbackScores,
  ListResponse,
} from "types/apiTypes";
import { RequestMethods } from "types/enums";
import { Query } from "../types";
import { prepareQuery } from "../utils/prepareQuery";

export const feedbackApi = createApi({
  reducerPath: "feedbackApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["analytics", "feedbacks"],
  endpoints: (builder) => ({
    getFeedbacksAnalytics: builder.query<FeedbackAnalytics, Query>({
      query: (query) => ({
        url: `/feedbacks/analytics${prepareQuery(query)}`,
        method: RequestMethods.GET,
      }),
      providesTags: ["analytics"],
    }),

    getFeedbacks: builder.query<ListResponse<Feedback>, Query>({
      query: (query) => ({
        url: `/feedbacks${prepareQuery(query)}`,
        method: RequestMethods.GET,
      }),
      providesTags: ["feedbacks"],
    }),

    addFeedback: builder.mutation<
      void,
      FeedbackMessages & { files: File[] } & FeedbackScores
    >({
      query: (body) => {
        const formData = new FormData();
        for (const [key, value] of Object.entries(body)) {
          if (key === "files" && Array.isArray(value)) {
            value.forEach((el) => formData.append("files", el));
          } else {
            if (value !== undefined && value !== null)
              formData.append(key, String(value));
          }
        }

        return {
          url: "/feedbacks",
          method: RequestMethods.POST,
          body: formData,
        };
      },
      invalidatesTags: ["feedbacks", "analytics"],
    }),
  }),
});

export const {
  useGetFeedbacksAnalyticsQuery,
  useGetFeedbacksQuery,
  useAddFeedbackMutation,
} = feedbackApi;
